import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';

import { sendZapHook } from '../lib/zaps';

const SignupMessageSchema = z.object({
  email: z.string().email(),
  existingDocumentation: z.array(z.string()),
  existingDiagrams: z.array(z.string()),
  frustrations: z.array(z.string()),
  plan: z.string().optional(),
  posthogSessionId: z.string().optional(),
});

export const sendSignupMessage = createServerFn({
  method: 'POST',
})
  .validator((data: unknown) => SignupMessageSchema.parse(data))
  .handler(async (ctx) => {
    await sendZapHook({
      type: 'signup-form',
      data: {
        email: ctx.data.email,
        plan: ctx.data.plan,
        existingDiagrams: ctx.data.existingDiagrams,
        existingDocumentation: ctx.data.existingDocumentation,
        frustrations: ctx.data.frustrations,
        posthogSessionId: ctx.data.posthogSessionId,
      },
    });

    return {
      message: 'Signup form submitted',
    };
  });
